import { render, staticRenderFns } from "./Capacities.vue?vue&type=template&id=254d7065&scoped=true&"
import script from "./Capacities.vue?vue&type=script&lang=js&"
export * from "./Capacities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254d7065",
  null
  
)

export default component.exports